/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type VisibilityBoardAddressRowList_list$ref = any;
export type visibilityBoardAddress_deleteVisibilityBoardAddress_MutationVariables = {|
  visibilityBoardAddressId: any
|};
export type visibilityBoardAddress_deleteVisibilityBoardAddress_MutationResponse = {|
  +visibilityBoardAddressMutation: ?{|
    +deleteVisibilityBoardAddressEntry: ?$ReadOnlyArray<?{|
      +$fragmentRefs: VisibilityBoardAddressRowList_list$ref
    |}>
  |}
|};
export type visibilityBoardAddress_deleteVisibilityBoardAddress_Mutation = {|
  variables: visibilityBoardAddress_deleteVisibilityBoardAddress_MutationVariables,
  response: visibilityBoardAddress_deleteVisibilityBoardAddress_MutationResponse,
|};
*/


/*
mutation visibilityBoardAddress_deleteVisibilityBoardAddress_Mutation(
  $visibilityBoardAddressId: UUID!
) {
  visibilityBoardAddressMutation {
    deleteVisibilityBoardAddressEntry(visibilityBoardAddressId: $visibilityBoardAddressId) {
      ...VisibilityBoardAddressRowList_list
      id
    }
  }
}

fragment VisibilityBoardAddressRowList_list on VisibilityBoardAddress {
  ...VisibilityBoardAddressRow_rowData
}

fragment VisibilityBoardAddressRow_rowData on VisibilityBoardAddress {
  id
  address
  description
  visibilityBoard {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "visibilityBoardAddressId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "visibilityBoardAddressId",
    "variableName": "visibilityBoardAddressId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "visibilityBoardAddress_deleteVisibilityBoardAddress_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoardAddressMutation",
        "kind": "LinkedField",
        "name": "visibilityBoardAddressMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "VisibilityBoardAddress",
            "kind": "LinkedField",
            "name": "deleteVisibilityBoardAddressEntry",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "VisibilityBoardAddressRowList_list"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "visibilityBoardAddress_deleteVisibilityBoardAddress_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VisibilityBoardAddressMutation",
        "kind": "LinkedField",
        "name": "visibilityBoardAddressMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "VisibilityBoardAddress",
            "kind": "LinkedField",
            "name": "deleteVisibilityBoardAddressEntry",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "VisibilityBoard",
                "kind": "LinkedField",
                "name": "visibilityBoard",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dcd873efec2a7f19fbcc024e60d742f7",
    "id": null,
    "metadata": {},
    "name": "visibilityBoardAddress_deleteVisibilityBoardAddress_Mutation",
    "operationKind": "mutation",
    "text": "mutation visibilityBoardAddress_deleteVisibilityBoardAddress_Mutation(\n  $visibilityBoardAddressId: UUID!\n) {\n  visibilityBoardAddressMutation {\n    deleteVisibilityBoardAddressEntry(visibilityBoardAddressId: $visibilityBoardAddressId) {\n      ...VisibilityBoardAddressRowList_list\n      id\n    }\n  }\n}\n\nfragment VisibilityBoardAddressRowList_list on VisibilityBoardAddress {\n  ...VisibilityBoardAddressRow_rowData\n}\n\nfragment VisibilityBoardAddressRow_rowData on VisibilityBoardAddress {\n  id\n  address\n  description\n  visibilityBoard {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'eb6902abec9906a08b23a77519fd931c';

module.exports = node;
